const configApi = {
  API_LOCATION: process.env.VUE_APP_API_LOCATION + '/v1',
  NAME_TOKEN_LOCAL_STORAGE: '_access_token',
  ROLES_LOCAL_STORAGE: '_user_roles',
  INLINE_PIXEL_CDN: 'https://cdn.truffle.bid/p/inline-pixel.js',
  FILTER_LOCAL_STORAGE: '_filter',
  SENTRY_DNS: 'https://ff5fa9a6b8c94faca5106150768a3397@sentry.truffle.bid/7'
}
export default configApi
